exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tutorial-section *{margin:calc(var(--section-padding-height)/2) 0}", ""]);

// exports
